import { isBrowser } from "@/utils/platform";
export async function initDevMocks() {
  try {
    if (!isBrowser()) return;

    if (import.meta.env.MODE === "development") {
      const { setupWorker } = await import("node_modules/msw/lib/browser/index");
      const { handlers } = await import("@/mocks/handlers");

      const mocksWorker = setupWorker(...handlers);
      mocksWorker.start({ quiet: true });
    }
  } catch (e) {
    console.error("@@@", e);
    /* empty */
  }
}
